import {
  asset,
  device,
  deviceGroup,
  deviceScreenShot,
  feed,
  notification,
  playlist,
  playlistItem,
  channel,
  channelItem,
  scheduledContent,
  scheduledDailyContent,
  specialContent,
  ticker,
  tickerSeries,
  userProfile,
  webAssetTemplate,
  customWebAssetTemplate,
  subUsers,
  myClient,
  profileUser,
  assetList,
  campaign,
  playlistTag,
  deviceTag,
  userReports,
  scrollerTemplates,
  playlistV2,
  assetTag,
} from "./schema";

/**
 * These constants define the resource names for different types of data used by our app. The
 * values of these resources correspond to the API path at which the resource can be accessed.
 */
export const DEVICE_GROUPS_RESOURCE = "device_groups";
export const DEVICE_UNGROUP_WRAPERS_RESOURCE = "device_ungrouped_wrapers";
export const SCHEDULED_CONTENT_RESOURCE = "scheduled_content";
export const SCHEDULED_CONTENT_BULK_UPDATE_RESOURCE =
  "scheduled_content/bulk_update";
export const SCHEDULED_DAILY_CONTENT_RESOURCE = "scheduled_daily_content";
export const SCHEDULED_DAILY_CONTENT_BULK_UPDATE_RESOURCE =
  "scheduled_daily_content/bulk_update";
export const SPECIAL_CONTENT_RESOURCE = "special_content";
export const CONTENT_FEEDS_RESOURCE = "content_feeds";
export const DEVICES_RESOURCE = "devices";
export const DEVICE_SCREENSHOTS_RESOURCE = "device_screenshots";
export const UNGROUPED_DEVICES_RESOURCE = "devices/ungrouped";
export const PLAYLISTS_RESOURCE = "playlists";
export const PLAYLISTS_RESOURCE_V2 = "playlistsV2";
export const PLAYLIST_ITEMS_RESOURCE = "playlist_items";
export const CHANNELS_RESOURCE = "channels";
// export const CHANNEL_ITEMS_RESOURCE = 'channel_items'; // channel_items ?
export const TICKER_SERIES_RESOURCE = "ticker_series";
export const TICKERS_RESOURCE = "tickers";
export const ASSETS_RESOURCE = "assets";
export const CAMPAIGN_RESOURCE = "campaign";
export const IMAGE_RESOURCE = "image_assets";
export const AUDIO_RESOURCE = "audio_assets";
export const VIDEO_RESOURCE = "video_assets";
export const PDF_RESOURCE = "pdf_assets";
export const WEB_RESOURCE = "web_assets";
export const FEED_RESOURCE = "feed_assets";
export const CALENDAR_RESOURCE = "calendar_assets";
export const URL_RESOURCE = "url_assets";
export const AQI_RESOURCE = "aqi_assets";
export const AQI_VEDA_RESOURCE = "aqi_veda_assets";
export const QUIZ_RESOURCE = "quiz_assets";
export const WEB_TEMPLATE_RESOURCE = "web_asset_templates";
export const USER_RESPORT_ACTIIVITIES_RESOURCE = "user_reports";
export const CUSTOM_WEB_TEMPLATE_RESOURCE = "custom_web_asset_templates";
export const SCROLLER_TEMPLATE_RESOURCE = "scroller_ticker_bg"
export const ZIP_RESOURCE = "web_zip_assets";
export const NOTIFICATION_RESOURCE = "notifications";
export const PROFILE_RESOURCE = "auth/me";
export const CLIENT_RESOURCE = "client";
export const TICKER_FEED_RESOURCE = "ticker_feed";
export const FIDS_RESOURCE = "fids_assets";
export const SUBUSER_RESOURCE = "sub_users";
export const USERPROFILE_RESOURCE = "user_profile";
export const PLAYLIST_TAGS_RESOURCE = "playlist_tags";
export const DEVICE_TAGS_RESOURCE = "device_tags";
export const ASSETS_TAGS_RESOURCE = "assets_tags";

/**
 * This object maps the API resource to the normalizr schema that that can be used to normalise it.
 */
export const SCHEMAS = {
  [DEVICE_GROUPS_RESOURCE]: deviceGroup,
  [DEVICE_UNGROUP_WRAPERS_RESOURCE]: deviceGroup,
  [SCHEDULED_CONTENT_RESOURCE]: scheduledContent,
  [SCHEDULED_CONTENT_BULK_UPDATE_RESOURCE]: [scheduledContent],
  [SCHEDULED_DAILY_CONTENT_RESOURCE]: scheduledDailyContent,
  [SCHEDULED_DAILY_CONTENT_BULK_UPDATE_RESOURCE]: [scheduledDailyContent],
  [SPECIAL_CONTENT_RESOURCE]: specialContent,
  [CONTENT_FEEDS_RESOURCE]: feed,
  [DEVICE_SCREENSHOTS_RESOURCE]: deviceScreenShot,
  [DEVICES_RESOURCE]: device,
  [UNGROUPED_DEVICES_RESOURCE]: device,
  [PLAYLISTS_RESOURCE]: playlist,
  [PLAYLISTS_RESOURCE_V2]: playlistV2,
  [PLAYLIST_TAGS_RESOURCE]: playlistTag,
  [DEVICE_TAGS_RESOURCE]: deviceTag,
  [ASSETS_TAGS_RESOURCE]: assetTag,
  [USER_RESPORT_ACTIIVITIES_RESOURCE]:userReports,
  [PLAYLIST_ITEMS_RESOURCE]: playlistItem,
  [CHANNELS_RESOURCE]: channel,
  // [CHANNEL_ITEMS_RESOURCE]: channelItem,
  [TICKER_SERIES_RESOURCE]: tickerSeries,
  [TICKERS_RESOURCE]: ticker,
  [CAMPAIGN_RESOURCE]: campaign,
  [ASSETS_RESOURCE]: asset,
  [IMAGE_RESOURCE]: asset,
  [AUDIO_RESOURCE]: asset,
  [VIDEO_RESOURCE]: asset,
  [PDF_RESOURCE]: asset,
  [WEB_RESOURCE]: asset,
  [URL_RESOURCE]: asset,
  [AQI_RESOURCE]: asset,
  [FEED_RESOURCE]: asset,
  [CALENDAR_RESOURCE]: asset,
  [FIDS_RESOURCE]: asset,
  [AQI_VEDA_RESOURCE]: asset,
  [QUIZ_RESOURCE]: asset,
  [ZIP_RESOURCE]: asset,
  [WEB_TEMPLATE_RESOURCE]: webAssetTemplate,
  [CUSTOM_WEB_TEMPLATE_RESOURCE]: customWebAssetTemplate,
  [SCROLLER_TEMPLATE_RESOURCE] : scrollerTemplates,
  [PROFILE_RESOURCE]: userProfile,
  [CLIENT_RESOURCE]: myClient,
  [NOTIFICATION_RESOURCE]: notification,
  [SUBUSER_RESOURCE]: subUsers,
  [USERPROFILE_RESOURCE]: profileUser,
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/api/resources.js